"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function rgbaString(rgba) {
    return 'rgba(' + rgba.join(',') + ')';
}
exports.rgbaString = rgbaString;
//# sourceMappingURL=rgbaString.js.map


//////////////////
// WEBPACK FOOTER
// ./~/color-map/dist-es5/rgbaString.js
// module id = 582
// module chunks = 0